module.exports = __webpack_public_path__ + "static/media/Tower.3e14fd07.png";